import { render, staticRenderFns } from "./user-info-for-conference.html?vue&type=template&id=b5d3981a&scoped=true&external"
import script from "./user-info-for-conference.js?vue&type=script&lang=js&external"
export * from "./user-info-for-conference.js?vue&type=script&lang=js&external"
import style0 from "./user-info-for-conference.scss?vue&type=style&index=0&id=b5d3981a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d3981a",
  null
  
)

export default component.exports